module.exports = __webpack_public_path__ + "2636e0dbf191f858748a9f70db1ef996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-penguin-sorry.png
// module id = 2053
// module chunks = 4